import React from "react";
import { convertStylesStringToObject } from "@/utils";

const ContactInfoSection = ({ fields }) => {
  return (
    <div
      className="contact-container"
      style={convertStylesStringToObject(fields?.paddingBottom?.value)}
    >
      <span>{fields?.MainTitle?.value}</span>
      <div
        className="line"
        style={convertStylesStringToObject(fields?.lineStyle?.value)}
      />
      {fields?.EmailTitle?.value && (
        <div className="mail-align-left">{fields?.EmailTitle?.value}</div>
      )}
      <div className="mail-display">
        <div className="mail-size">
          <div>
            <div className="letter-img-display">
              <div className="letter-img" />
              <div className="letter-img-text">{fields?.Email?.value}</div>
            </div>
            <div className="letter-text-display">
              {fields?.UnderEmailDesc?.value}
            </div>
          </div>
        </div>
        <div
          className="mail-description"
          dangerouslySetInnerHTML={{
            __html: fields?.RightEmailDesc?.value.replace(/\r?\n/g, "<br>"),
          }}
        />
      </div>

      {/* <div className="tel-align-left">{fields?.PhoneTitle?.value}</div>
      <div className="mail-display">
        <div className="mail-size">
          <div>
            <div className="letter-img-display">
              <div className="let-img" />
              <div className="letter-let-text">
                {fields?.PhoneNumber?.value}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            className="mail-description"
            dangerouslySetInnerHTML={{
              __html: fields?.PhoneDesc?.value.replace(/\r?\n/g, "<br>"),
            }}
          />
        </div>
      </div> */}
    </div>
  );
};

export default ContactInfoSection;
